<template>
  <div class="student-manangment">
    <!-- TITLE -->
    <ots-main-title :mainTopBtn="mainTopBtnList"></ots-main-title>
    <!-- Table 表格, Select 搜索表单 -->
    <ots-table-group-new
      :selectList="selectList"
      :requestForm="requestForm"
      @search="searchListFN"
      :tableHeader="tableHeader"
      :tableData="tableData"
      :pagination="pagination"
      @changeNum="changeSize"
      @changePage="changePage"
    ></ots-table-group-new>
    <!-- ResetPassWord 重置密码 -->
    <ots-custom-dialog :dialog.sync="repeatPsdDialog" title="重置密码" width="40%">
      <template v-slot:content>
        <div class="repeatPsd">
          确定将考生<span> {{ editPsdQuery.realName }} </span>的密码重置？重置后，密码为其<span>证件号后六位（不够六位前面补0）</span>
        </div>
      </template>
      <template v-slot:footer>
        <el-button round @click="repeatPsdDialog = false">取消</el-button>
        <el-button round type="primary" @click="submitRepeatPsd">确定</el-button>
      </template>
    </ots-custom-dialog>
    <!-- Edit 修改用户信息 -->
    <ots-custom-dialog :dialog.sync="EditDialog" title="编辑注册用户信息" width="40%">
      <template v-slot:content>
        <div class="exportDialog">
          <el-form :model="EditStudentInfo" :rules="EditRules" ref="form">
            <el-form-item label="姓名" prop="realName">
              <el-input v-model.trim="EditStudentInfo.realName" placeholder="请输入用户名"></el-input>
            </el-form-item> 
            <el-form-item label="证件类型" prop="cardType">
              <el-select v-model="EditStudentInfo.cardType" placeholder="请选择证件类型">
                <el-option
                  v-for="item in cardTypeList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="证件号" prop="cardNo">
              <el-input v-model.trim="EditStudentInfo.cardNo" placeholder="请输入证件号"></el-input>
            </el-form-item> 
            <el-form-item label="手机号" prop="phone">
              <el-input v-model="EditStudentInfo.phone" placeholder="请输入手机号"></el-input>
            </el-form-item>
          </el-form>
        </div>
      </template>
      <template v-slot:footer>
        <el-button round @click="EditDialog = false">取消</el-button>
        <el-button round type="primary" @click="EditStudentInfoFN">确定</el-button>
      </template>
    </ots-custom-dialog>
    
  </div>
</template>

<script>
import {checkPhone, checkCardId} from "../../common/verify";
export default {
  data () {
    return {
      // 页面 TITLE
      mainTopBtnList : [],
      // 证件类型
      cardTypeList: [
        { id: "1", name: "身份证" },
        { id: "2", name: "护照" },
        { id: "3", name: "士官证" },
        { id: "4", name: "港澳台身份证" },
      ],
      // 控制编辑弹窗显示情况
      EditDialog: false,
      // 编辑用户信息
      EditStudentInfo: {
        id: "",
        realName: "",
        cardType: "",
        cardNo: "",
        phone: "",
      },
      // 编辑用户信息表单"验证规则"
      EditRules: {
        realName: [
          { required: true, message: "请输入姓名", trigger: "blur" },
        ],
        cardType: [
          { required: true, message: "请选择证件类型", trigger: "change" }
        ],
        cardNo: [
          { required: true, message: "请输入证件号", trigger: "blur" },
          { message: "身份证格式错误", trigger: "blur", validator: this.checkCardId }
        ],
        phone: [
          { required: true, message: '请输入正确的手机号', trigger: 'blur', validator: checkPhone },
        ],
      },
      // 重置密码参数
      editPsdQuery: {
        realName: "",
        userId: "",
        password: "",
        confirmPassword: "",
      },
      // 搜索表单配置
      selectList: [
        {
          title: "姓名",
          type: "input",
          requestKey: "realName",
          placeholder: "请输入"
        },
        {
          title: "证件号",
          type: "input",
          requestKey: "cardNo",
          placeholder: "请输入"
        },
        {
          title: "手机号",
          type: "input",
          requestKey: "phone",
          placeholder: "请输入"
        },
        {
          title: "报名状态",
          type: "select",
          requestKey: "applyState",
          label: "name",
          value: "id",
          data: [
            { id: "", name: "全部" },
            { id: 1, name: "是" },
            { id: 0, name: "否" }
          ]
        }
      ],
      // 表格头
      tableHeader: [
        {
          title: "姓名",
          prop: "realName",
          width: '120'
        },
        {
          title: "证件类型",
          prop: "cardType"
        },
        {
          title: "证件号",
          prop: "cardNo",
        },
        {
          title: "手机号",
          prop: "phone",
        },
        {
          title: "报名状态",
          prop: "applyState",
        },
        {
          title: "操作",
          type: "buttons",
          fixed: "right",
          align: "right",
          headerAlign: "right",
          btnList: [
            {
              title: "重置密码",
              click: this.repeatPsd,
            },
            {
              title: "编辑",
              click: this.edit,
            },
            {
              title: "删除",
              formatter: (scope) => {
                if (scope.row.applyState == "是") {
                  return true;
                } else {
                  return false;
                }
              },
              click: this.delet,
            },
          ],
        },
      ],
      // 表格数据
      tableData: [],
      // 分页数据
      pagination: {
        total: 0,
      },
      // 重置密码弹窗控制显示
      repeatPsdDialog: false,
      // 请求表单参数
      requestForm: {
        realName: "",
        cardNo: "",
        phone: "",
        applyState: "",
        page: 1,
        size: 10,
      },
    }
  },
  mounted() {
    this.searchList();
  },
  methods: {
    // 身份证格式验证
    checkCardId(rule, value, callback) {
      return checkCardId(rule, value, callback, this.EditStudentInfo.cardType);
    },
    // 搜索按钮
    searchListFN(){
      this.requestForm.page = 1;
      this.searchList();
    },
    // 查询表格数据
    searchList() {
      let params = { ...this.requestForm }
      this.$api.applyManage.selectRegisterUserList(params).then( (res) => {
        if (res.code == 1) {
          this.tableData = res.data.records;
          this.pagination.total = res.data.total;
        }
      })
    },
    // 重置密码
    repeatPsd(val) {
      this.repeatPsdDialog = true;
      let { cardNo } = val;
      let resetPassword = "";
      let hanzi = new RegExp("[\u4e00-\u9fa5]");
      if (hanzi.test(cardNo)) {
        resetPassword = "000000";
      } else if (cardNo.length >= 6) {
        resetPassword = cardNo.substring(cardNo.length - 6);
      } else {
        let zeroNum = 6 - cardNo.length;
        for (let i = 0; i < zeroNum; i++) { resetPassword = resetPassword + "0" };
        resetPassword = resetPassword + cardNo;
      }
      this.editPsdQuery = {
        realName: val.realName,
        userId: val.id,
        password: resetPassword,
        confirmPassword: resetPassword,
        tenant: window.localStorage.getItem("tenant")
      }
    },
    // 执行重置密码
    submitRepeatPsd() {
      let params = { ...this.editPsdQuery };
      this.$api.login.editPsd(params).then((res) => {
        if (res.code) {
          this.repeatPsdDialog = false;
          this.$message.success('密码修改成功！');
        }
      });
    },
    // 编辑
    edit(val){
      this.EditDialog = true;
      this.EditStudentInfo.id = val.id;
      this.EditStudentInfo.realName = val.realName;
      this.cardTypeList.map( item => {
        if (item.name == val.cardType) {
          this.EditStudentInfo.cardType = item.id;
        }
      })
      this.EditStudentInfo.cardNo = val.cardNo;
      this.EditStudentInfo.phone = val.phone;
    },
    // 执行编辑
    EditStudentInfoFN() {
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          let params = { ...this.EditStudentInfo };
          let { cardNo } = params;
          let resetPassword = "";
          let hanzi = new RegExp("[\u4e00-\u9fa5]");
          if (hanzi.test(cardNo)) {
            resetPassword = "000000";
          } else if (cardNo.length >= 6) {
            
            resetPassword = cardNo.substring(cardNo.length - 6);
          } else {
            let zeroNum = 6 - cardNo.length;
            for (let i = 0; i < zeroNum; i++) { resetPassword = resetPassword + "0" };
            resetPassword = resetPassword + cardNo;
          }
          let paramsPwd = {
            realName: params.realName,
            userId: params.id,
            password: resetPassword,
            confirmPassword: resetPassword,
            tenant: window.localStorage.getItem("tenant")
          }

          this.$api.applyManage.updateRegisterUserInfo(params).then( res => {
            if (res.code == 1) {
              return this.$api.login.editPsd(paramsPwd);
            }
          }).then((res) => {
            if (res.code) {
              this.$message.success("操作成功！");
              this.searchList();
              this.EditDialog = false;
            }
          })
        } else {
          return false;
        }
      })
    },
    // 删除
    delet(val){
      this.$confirm(`确定将考生“${val.realName}”删除？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$api.applyManage.deleteRegisterUserInfo({stuId: val.id}).then( res => {
          if (res.code == 1) {
            this.searchList();
            this.$message.success("删除成功！");
          }
        })
      })
    },
    // 分页,修改每页显示数量
    changeSize(num) {
      this.requestForm.size = num;
      this.searchList();
    },
    // 翻页
    changePage(p) {
      this.requestForm.page = p;
      this.searchList();
    },
  }
}
</script>

<style lang="less" scoped>
.el-alert {
    margin-bottom: 24px;
    background: #F0F9EB;
    border: 1px solid #67C23A;
    height: 48px;
    line-height: 48px;
    box-sizing: border-box;  
    .importantNote {
      font-size: 14px;
      color: #67C23A;
      margin-left: -10px;
      margin-top: -7px;
    }
    /deep/ .el-alert__closebtn {
      top: 17px;
      color: #67C23A;
    }
}
</style>